import { Slide } from "@jelly/lesson";

import theory from "../../theory";
import config from "appConfig";

import horn40db from "./components/horn-40-db";
import horn43db from "./components/horn-43-db";
import horn46db from "./components/horn-46-db";
import horn49db from "./components/horn-49-db";
import horn52db from "./components/horn-52-db";
import horn55db from "./components/horn-55-db";
import horn58db from "./components/horn-58-db";
import horn61db from "./components/horn-61-db";
import horn64db from "./components/horn-64-db";
import horn67db from "./components/horn-67-db";
import horn70db from "./components/horn-70-db";
import horn73db from "./components/horn-73-db";
import horn76db from "./components/horn-76-db";
import horn79db from "./components/horn-79-db";
import horn82db from "./components/horn-82-db";
import horn85db from "./components/horn-85-db";
import horn88db from "./components/horn-88-db";
import horn91db from "./components/horn-91-db";
import horn94db from "./components/horn-94-db";
import horn97db from "./components/horn-97-db";
import horn100db from "./components/horn-100-db";

const principle: Slide = {
  description:
    "The dB scale is a non linear scale depicting the acoustic level and where +3 dB (+10 dB) is equivalent to have multiply by 2 (10) the pressure amplitude. To have a better understanding of this scale, it is here proposed, after a preliminary setup of your volume, to travel along the dB scale! First, click on the “preliminary setting” button and set your volume such that you barely hear the beep (~20 dB SPL). Once this is set, select the dB scale or sound landscape and listen to the different level!",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "layout",
        data: {
          type: "table",
          options: {
            cols: 2,
            rows: 3,
            rowsSize: [0.5, 3, 1],
            colSpan: {
              "0:0": 2,
              "1:0": 2,
            },
            colsSize: [11, 1],
            components: [
              [
                {
                  variant: "blockContainer",
                  data: {
                    block: {
                      type: "text",
                      options: {
                        data: "<b>dB scale</b>",
                        scrollbars: false,
                        formatter: "html",
                      },
                    },
                    styles: {
                      textTransform: "uppercase",
                      letterSpacing: "0.25em",
                      alignItems: "flex-end",
                      paddingBottom: "1%",
                    },
                  },
                },
              ],
              [
                {
                  variant: "blockContainer",
                  data: {
                    block: {
                      type: "image",
                      options: {
                        src: `${config.ASSETS_URL}/01/22/principle/boat.png`,
                      },
                    },
                  },
                },
              ],
              [
                {
                  variant: "layout",
                  data: {
                    type: "slidersToggle",
                    options: {
                      labels: [
                        [
                          { name: "40" },
                          { name: "43" },
                          { name: "46" },
                          { name: "49" },
                          { name: "52" },
                          { name: "55" },
                          { name: "58" },
                          { name: "61" },
                          { name: "64" },
                          { name: "67" },
                          { name: "70" },
                          { name: "73" },
                          { name: "76" },
                          { name: "79" },
                          { name: "82" },
                          { name: "85" },
                          { name: "88" },
                          { name: "91" },
                          { name: "94" },
                          { name: "97" },
                          { name: "100" },
                        ],
                      ],
                      components: [
                        horn40db,
                        horn43db,
                        horn46db,
                        horn49db,
                        horn52db,
                        horn55db,
                        horn58db,
                        horn61db,
                        horn64db,
                        horn67db,
                        horn70db,
                        horn73db,
                        horn76db,
                        horn79db,
                        horn82db,
                        horn85db,
                        horn88db,
                        horn91db,
                        horn94db,
                        horn97db,
                        horn100db,
                      ],
                    },
                  },
                },
                {
                  variant: "blockContainer",
                  data: {
                    block: {
                      type: "text",
                      options: {
                        data: "db SPL",
                        scrollbars: false,
                        styles: {
                          fontSize: "12px",
                          fontWeight: 600,
                          lineHeight: "16px",
                        },
                      },
                    },
                    styles: {
                      alignItems: "flex-end",
                    },
                  },
                },
              ],
            ],
          },
        },
      },
    },
    styles: {
      padding: "0 2% 0 0",
    },
  },
};

export default principle;
